import { Toaster } from "@ark-ui/solid";
import { X } from "lucide-solid";
import { children, Show } from "solid-js";
import { Portal } from "solid-js/web";
import { Button } from "~/solidJs/shared";
import { StyledToast } from "../../shared/ui/molecules";
import { type ToastMessageTypes, type ToastMeta, toaster } from "./toaster";

export { showToastMessage, ToastMessageTypes } from "./toaster";

export const WorkspaceToaster = () => {
	return (
		<Portal>
			<Toaster toaster={toaster}>
				{(toast) => {
					const renderContent = children(() => {
						const meta = toast().meta as ToastMeta;
						return meta.RenderAs;
					});
					return (
						<StyledToast.Root toastType={toast().type as ToastMessageTypes}>
							<Show
								fallback={
									<>
										<div class="flex flex-col gap-1" translate="no">
											<StyledToast.Title>{toast().title}</StyledToast.Title>
											<Show when={toast().description} keyed>
												{(descr) => (
													<StyledToast.Description>
														{descr}
													</StyledToast.Description>
												)}
											</Show>
										</div>
										<StyledToast.CloseTrigger
											asChild={(p) => (
												<Button {...p()} variant="OverlayIcon" />
											)}
										>
											<X size={16} />
										</StyledToast.CloseTrigger>
									</>
								}
								when={renderContent()}
							>
								{renderContent()}
							</Show>
						</StyledToast.Root>
					);
				}}
			</Toaster>
		</Portal>
	);
};
